import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
/* Layout */
import Layout from '../layout'

/* Router Modules */
// import docs from './modules/docs'
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   如果设置为true,就不会显示在左侧的菜单，比如订单详情，这一类页面就不需要设置为true,默认情况下为false
 * alwaysShow: true               如果设置为true，无论有没有子菜单都会显示在左侧菜单，如果设置为false，没有子菜单，该菜单就不会显示
 * redirect: 'noRedirect'         如果设置'noRedirect',在面包屑当中就不会重定向
 * name:'router-name'             必须设置名称，在 <keep-alive>用到 (must set!!!)
 * meta : {
    roles: ['admin','editor']    页面权限配置
    title: 'title'               页面title，在面包屑显示
    icon: 'svg-name'             图标
    noCache: true                缓存设置
    affix: true                  如果设置为true， tag 将会固定在tags-view上
    breadcrumb: false            是否在面包屑上显示(default is true)
    activeMenu: '/example/list'  左侧菜单栏菜单激活
  }
 */
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules.concat(value.default)
}, [])
/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/404',
    component: () => import('../views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    redirect:'/',
    // component: () => import('../views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    meta: { title: '企业寄件-产品介绍', affix: true },
    component: () => import('../home'),
    hidden: true
  },

  {
    path: '/main',
    component: Layout,
    redirect: '/main/index',
    children: [
      {
        path: 'rechage-success',
        component: () => import('../views/order/success'),
        name: 'RechargeSuccess',
        meta: { title: '充值成功', affix: true }
      },
      {
        path: 'index',
        component: () => import('../views/index/index'),
        name: 'Dashboard',
        meta: { title: '主页', affix: true },
        children: [{
          path: 'not-enough',
          component: () => import('../views/notEnough'),
          name: 'NotEnough',
          meta: { title: '余额不足', affix: true }
        }]
      },
      {
        path: 'send',
        component: () => import('../views/send/index'),
        name: 'Send',
        meta: { title: '在线寄件', affix: true },
        children: [{
          path: 'waybill-query',
          component: () => import('../views/send/waybill-query'),
          name: 'WaybillQuery',
          meta: { title: '价格查询-快递鸟企业寄件', affix: true }
        }]
      },
      {
        path: 'search',
        component: () => import('../views/search/index'),
        name: 'Search',
        meta: { title: '订单监控', affix: true },
        children: [
          {
            path: 'success',
            component: () => import('../views/success'),
            name: 'Success',
            meta: { title: '下单成功', affix: true }
          }
        ]
      },

      {
        path: 'statistics',
        component: () => import('../views/statistics/index'),
        name: 'Statistics',
        meta: { title: '寄件统计', affix: true }
      },
      {
        path: 'trace',
        component: () => import('../views/trace/index'),
        name: 'Trace',
        meta: { title: '单号查询 - 查快递、寄件快递  快递鸟企业寄件', affix: true }
      },
      {
        path: 'manager',
        component: () => import('../views/manager/index'),
        name: 'Manager',
        meta: { title: '企业管理', affix: true },
        redirect: '/main/manager/order',
        children: [
          {
            path: 'order',
            component: () => import('../views/order/index'),
            name: 'Order',
            meta: { title: '账户管理', affix: true },
            children: [
              {
                path: 'recharge',
                component: () => import('../views/order/recharge'),
                name: 'Recharge',
                meta: { title: '充值', affix: true },
                children: [
                  {
                    path: 'success',
                    component: () => import('../views/order/success'),
                    name: 'RechargeSuccess',
                    meta: { title: '充值成功', affix: true }
                  }
                ]
              }
            ]
          },
          {
            path: 'settlement-settings',
            component: () => import('../views/manager/settlement-settings'),
            name: 'SettlementSettings',
            meta: { title: '快递结算设置', affix: true }
          },
          {
            path: 'employee-management',
            component: () => import('../views/manager/employee-management'),
            name: 'EmployeeManagement',
            meta: { title: '部门员工管理', affix: true }
          },
          {
            path: 'company-info-management',
            component: () => import('../views/manager/company-info-management'),
            name: 'CompanyInfoManagement',
            meta: { title: '公司信息管理', affix: true }
          },
          {
            path: 'personal-info-management',
            component: () => import('../views/manager/personal-info-management'),
            name: 'PersonalInfoManagement',
            meta: { title: '公司信息管理', affix: true }
          }
        ]
      },
      {
        path: 'address',
        component: () => import('../views/address/index'),
        name: 'Address',
        meta: { title: '地址管理', affix: true }
      },
      {
        path: 'order-detail',
        component: () => import('../views/order/orderDetail'),
        name: 'Address',
        meta: { title: '订单详情', affix: true }
      }
    ]
  }

]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = []

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
